export const FETCHING = "FETCHING";
export const ERROR = "ERROR";
export const IDLE = "IDLE";
export const DELIVERY_EATIN = "EATIN";
export const DELIVERY_TAKEAWAY = "TAKEAWAY";
export const INACTIVITY_TIMEOUT = 60000
export const INACTIVITY_COUNTDOWN_SECONDS = 10
